"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnalytics = void 0;
var react_1 = require("react");
var AnalyticsData_1 = require("../AnalyticsData/AnalyticsData");
var AnalyticsProvider_1 = require("../AnalyticsProvider/AnalyticsProvider");
var ANALYTICS_CONTEXT_ERROR = "useAnalytics couldn't access the AnalyticsContext object.\n\nThis might be due to\n- useAnalytics was used outside a parent AnalyticsProvider\n- there are multiple versions of ui-tools installed and AnalyticsProvider was imported from a different one\n";
var DATA_CONTEXT_ERROR = "useAnalytics couldn't access the DataContext object.\n\nThis might be due to\n- useAnalytics was used outside a parent DataProvider\n- there are multiple versions of ui-tools installed and DataProvider was imported from a different one\n";
function useAnalytics() {
    var analytics = (0, react_1.useContext)(AnalyticsProvider_1.AnalyticsContext);
    var data = (0, react_1.useContext)(AnalyticsData_1.DataContext);
    if (analytics === null) {
        throw new Error(ANALYTICS_CONTEXT_ERROR);
    }
    if (data === null) {
        throw new Error(DATA_CONTEXT_ERROR);
    }
    var dispatch = function (_a) {
        var type = _a.type, name = _a.name, _b = _a.properties, properties = _b === void 0 ? {} : _b;
        analytics.dispatch({
            type: type,
            name: name,
            data: data,
            properties: properties,
        });
    };
    return { dispatch: dispatch };
}
exports.useAnalytics = useAnalytics;
